// extracted by mini-css-extract-plugin
export default {"component":"VrmInputMileage__component-SU1j","textCenter":"VrmInputMileage__textCenter-cyxJ"};